import { migration as invoiceOwnerTables } from "./001_invoice_owner_tables";
import { migration as purchaseCreditNotes } from "./002_purchase_credit_notes";
import { migration as legacyInvoiceOwnerBackfill } from "./003_backfill_legacy_invoice_owner_tables";
import { migration as paymentOwnerGuards } from "./004_payment_owner_guards";
import { migration as repairSalesInvoiceResequenceMarkers } from "./005_repair_sales_invoice_resequence_markers";
import { migration as ledgerPaymentRuntimeColumns } from "./006_ledger_payment_runtime_columns";
import { migration as removePaymentAllocationHeaderFk } from "./007_remove_payment_allocation_header_fk";
import { migration as removeInvoiceItemHeaderFk } from "./008_remove_invoice_item_header_fk";
import { migration as createReceiptsOwnerTable } from "./009_create_receipts_owner_table";

export const migrations = [
  invoiceOwnerTables,
  purchaseCreditNotes,
  legacyInvoiceOwnerBackfill,
  paymentOwnerGuards,
  repairSalesInvoiceResequenceMarkers,
  ledgerPaymentRuntimeColumns,
  removePaymentAllocationHeaderFk,
  removeInvoiceItemHeaderFk,
  createReceiptsOwnerTable,
];
